import socketClient from '../../clients/socketClient';

function getSocketUrl(windowId) {
    const currentDomain = process.env.REACT_APP_CUSTOM_ENVIRONMENT !== 'prod' ? "staging.app.thalamushq.ai" : "app.thalamushq.ai";
    return `wss://${currentDomain}/ws/connect?window_id=${windowId}`;
}

export function connectWebSocket(ws, keepAliveInterval, stopKeepAlivePings, newReceivedMessage, isRefreshing) {
  const windowId = window.name;

  const reconnectInterval = 1000; // Interval for reconnecting if the connection closes
  let backoffTime = 0;

  function startKeepAlivePings() {
    if (keepAliveInterval.current) return; // Prevent duplicate intervals
    keepAliveInterval.current = setInterval(() => {
      if (ws?.current?.readyState === WebSocket.OPEN) {
        ws?.current.send(JSON.stringify({ type: 'ping' }));
        console.log('Ping sent to server');
      }
    }, 30000); // 30 seconds
  }

  if (ws?.current?.readyState === WebSocket.OPEN) {
    console.log('[WebsocketInit] Already connected to ws, exiting');
    return
  }

  console.log("[WebsocketInit] Connecting...")
  socketClient.get('/request-new-connection').then(({ data }) => {
    console.log("[WebsocketInit] data in connect is", data)
    if (data.success == true) {
      ws.current = new WebSocket(
        getSocketUrl(windowId)
      );

      ws.current.onopen = () => {
        console.log('[WebsocketInit] WebSocket connection established');
        startKeepAlivePings(); // Start keep-alive pings
        backoffTime = 0
      };
  
      ws.current.onmessage = (event) => {
        const receivedMessage = event.data;
        const myData = JSON.parse(receivedMessage);
        newReceivedMessage(myData);
      };
  
      ws.current.onerror = (error) => {
        console.error('[WebsocketInit] WebSocket Error: ', error);
        console.log("[WebsocketInit] Closed error is ", error.currentTarget.readyState === WebSocket.CLOSED)
        if (error.currentTarget.readyState === WebSocket.CLOSED) {
          backoffTime += 1000;
        }
      };
  
      ws.current.onclose = (event) => {
        console.log('[WebsocketInit] WebSocket connection closed', event);
        stopKeepAlivePings(); // Stop pings
  
        if (!isRefreshing) {
          console.log("[WebSocketInit] reconnect timeout",reconnectInterval+backoffTime)
          setTimeout(() => connectWebSocket(ws, keepAliveInterval, stopKeepAlivePings, newReceivedMessage, isRefreshing), reconnectInterval+backoffTime); // Reconnect
        }
      };
    }
  })
}